import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'scoringCriteria',
  title: 'Scoring Criteria',
  type: 'document',
  fields: [
    defineField({
      name: 'name',
      title: 'Name',
      type: 'string',
      validation: (Rule) => Rule.required(),
    }),
  ],
})
